<template>
  <el-dialog
      :visible.sync="innerVisible"
      width="420px"
      custom-class="login-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="handleClose"
  >
    <template #title>
      <div class="dlg-title">
        <img v-if="logo" class="logo" :src="logo" alt="logo" />
        <div class="title-meta">
          <div class="brand">{{ brandName }}</div>
          <div class="subtitle">一键登录 · 极速直达</div>
        </div>
      </div>
    </template>

    <div class="card">
      <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-position="top"
          class="form"
      >
        <el-form-item label="手机号" prop="phone" class="form-item-tight">
          <el-input
              v-model.trim="form.phone"
              placeholder="请输入手机号"
              clearable
              maxlength="20"
              @keyup.enter.native="focusCode"
              prefix-icon="el-icon-mobile-phone"
          />
        </el-form-item>

        <el-form-item label="验证码" prop="code" class="form-item-tight">
          <div class="code-line">
            <el-input
                v-model.trim="form.code"
                placeholder="短信验证码"
                maxlength="10"
                ref="codeInput"
                @keyup.enter.native="onSubmit"
                class="code-input"
                prefix-icon="el-icon-message"
            />
            <el-button
                class="code-btn"
                type="primary"
                :disabled="!validPhone || sending || countdown>0"
                :loading="sending"
                @click="sendCode"
            >
              <span v-if="countdown===0">获取验证码</span>
              <span v-else>{{ countdown }}s</span>
            </el-button>
          </div>
        </el-form-item>

        <el-button
            class="submit-btn"
            type="primary"
            :loading="submitting"
            @click="onSubmit"
        >
          立即登录
        </el-button>

        <div class="agree">
          登录即表示同意
          <a class="link" href="javascript:;" @click="openPolicy('tos')">《用户协议》</a>
          与
          <a class="link" href="javascript:;" @click="openPolicy('privacy')">《隐私政策》</a>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { userApi } from '@/utils/api'
import config from '@/utils/config'

export default {
  name: 'LoginDialog',
  props: {
    brandName: { type: String, default: 'Suno导航' },
    logo: { type: String, default: '' }
  },
  data() {
    return {
      innerVisible: true, // 弹出即显示；关闭时向父组件 emit('close')
      form: { phone: '', code: '' },
      sending: false,
      submitting: false,
      countdown: 0,
      timer: null,
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: (_r, v, cb) => this.validPhone ? cb() : cb(new Error('手机号格式不正确')), trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  computed: {
    validPhone() {
      // 通用校验：至少6位数字；可替换为更严格的正则
      return /^\d{6,}$/.test(this.form.phone)
    }
  },
  methods: {
    handleClose() {
      this.clearTimer()
      this.$emit('close')
    },
    focusCode() {
      this.$refs.codeInput && this.$refs.codeInput.focus()
    },
    async sendCode() {
      if (!this.validPhone) {
        this.$message.warning('请先输入正确的手机号')
        return
      }
      try {
        this.sending = true
        const res = await userApi.sendVerificationCode(this.form.phone)
        if (res.code === 0) {
          this.$message.success('验证码已发送')
          this.startCountdown(60)
        } else {
          this.$message.error(res.msg || '发送失败')
        }
      } catch (_) {
        this.$message.error('网络异常，稍后再试')
      } finally {
        this.sending = false
      }
    },
    startCountdown(sec) {
      this.countdown = sec
      this.clearTimer()
      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          this.clearTimer()
          this.countdown = 0
        } else {
          this.countdown--
        }
      }, 1000)
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    onSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        try {
          this.submitting = true
          const res = await userApi.login({ phone: this.form.phone, code: this.form.code })
          if (res.code === 0) {
            // 按你的后端返回字段名调整
            const { token, userId,userPhone } = res.data || {}
            if (token) localStorage.setItem(config.storageKeys.authToken, token)
            if (userId) localStorage.setItem(config.storageKeys.userId, userId)
            if (userPhone) localStorage.setItem(config.storageKeys.userPhone, userPhone)


            this.$store.commit('setLoggedIn', !!token)
            if (userId) this.$store.commit('setUserId', userId)

            this.$message.success('登录成功')
            this.handleClose()
          } else {
            this.$message.error(res.msg || '登录失败')
          }
        } catch (_) {
          this.$message.error('网络异常，稍后再试')
        } finally {
          this.submitting = false
        }
      })
    },
    openPolicy(type) {
      if (type === 'privacy') {
        //this.$router.push({ path: '/privacy' });
        // 或者，在新标签页中打开
        window.open('/privacy', '_blank');
      }else {
        //this.$router.push({ path: '/terms' });
        // 或者，在新标签页中打开
        window.open('/terms', '_blank');
      }
    }
  },
  beforeDestroy() {
    this.clearTimer()
  }
}
</script>

<style scoped>
/* 标题区：更加品牌化 */
.dlg-title {
  display: flex; align-items: center;
}
.logo { width: 34px; height: 34px; border-radius: 10px; margin-right: 10px; }
.title-meta .brand {
  font-size: 18px; font-weight: 700;
  background: linear-gradient(90deg,#111,#4c4c4c);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent;
}
.title-meta .subtitle { font-size: 14px; color: #8c8c8c; margin-top: 5px; }

/* 卡片与表单：更紧凑的行距与留白 */
.card {
  background: #fff; border-radius: 14px;
  padding: 2px 2px 2px 2px;
}
.form { margin-top: 2px; }
.form-item-tight { margin-bottom: 12px; } /* 默认 22px 左右，这里缩小 */
.form-item-tight ::v-deep .el-form-item__label { margin-bottom: 4px; }

/* 验证码行：更贴近、更对齐 */
.code-line { display: flex; align-items: center; }
.code-input ::v-deep .el-input__inner { border-top-right-radius: 0; border-bottom-right-radius: 0; }
.code-btn {
  margin-left: 2px;               /* 关键：缩小间距 */
  height: 36px;                   /* 与 el-input 高度对齐 */
  padding: 0 12px;
  border-top-left-radius: 0;      /* 与输入框无缝衔接 */
  border-bottom-left-radius: 0;
  font-weight: 600;
}

/* 输入框统一外观：更现代的圆角与聚焦态 */
::v-deep .el-input__inner {
  height: 36px; border-radius: 10px;
}
::v-deep .el-input.is-focus .el-input__inner,
::v-deep .el-input__inner:focus {
  border-color: #409EFF; box-shadow: 0 0 0 2px rgba(64,158,255,0.12);
}

/* 提交按钮：更显眼 */
.submit-btn {
  width: 100%; height: 40px;
  margin-top: 6px; font-weight: 700; letter-spacing: .5px;
}

/* 协议行：更克制的辅助文字 */
.agree { text-align: center; margin-top: 8px; color: #909399; font-size: 12px; }
.link { color: #409EFF; text-decoration: none; }

/* 自定义对话框容器（与遮罩搭配更沉浸） */
::v-deep .login-dialog {
  border-radius: 16px; overflow: hidden;
  box-shadow: 0 18px 60px rgba(0,0,0,.16);
}
</style>
